import { Dayjs } from "dayjs";
import { z } from "zod";

export enum ModePaiement {
    ESPECE = "ESPECE",
    CARTE = "CARTE",
    CHEQUE = "CHEQUE",
    VIREMENT = "VIREMENT",
    WEB = "WEB",
}

export enum StatutPaiement {
    VALIDE = "VALIDE",
    ANNULE = "ANNULE",
}

export enum StatutReglement {
    NON_REGLE = "NON_REGLE",
    PARTIEL = "PARTIEL",
    SOLDE = "SOLDE",
    TROP_PERCU = "TROP_PERCU",
}

export enum TypeCiblePaiement {
    INSCRIPTION = "INSCRIPTION",
}

/**
 * Codes d'erreur renvoyés par le back dans le corps d'un 400. Toute valeur inconnue retombe sur le
 * message générique, cf. getLibelleErreurPaiement.
 */
export enum ErreurPaiement {
    CIBLE_INTROUVABLE = "CIBLE_INTROUVABLE",
    MONTANT_INVALIDE = "MONTANT_INVALIDE",
    MONTANT_SUPERIEUR_RESTE = "MONTANT_SUPERIEUR_RESTE",
    DATE_OBLIGATOIRE = "DATE_OBLIGATOIRE",
    DATE_FUTURE = "DATE_FUTURE",
    MODE_OBLIGATOIRE = "MODE_OBLIGATOIRE",
    MODE_WEB_NON_AUTORISE = "MODE_WEB_NON_AUTORISE",
    PAIEMENT_ANNULE_NON_MODIFIABLE = "PAIEMENT_ANNULE_NON_MODIFIABLE",
}

/**
 * Le mode WEB est réservé au règlement en ligne : le back le refuse en saisie manuelle, on ne le
 * propose donc pas dans le formulaire.
 */
export const MODES_PAIEMENT_SAISISSABLES: ModePaiement[] = [
    ModePaiement.ESPECE,
    ModePaiement.CARTE,
    ModePaiement.CHEQUE,
    ModePaiement.VIREMENT,
];

export const LIBELLES_MODE_PAIEMENT: Record<ModePaiement, string> = {
    [ModePaiement.ESPECE]: "Espèces",
    [ModePaiement.CARTE]: "Carte",
    [ModePaiement.CHEQUE]: "Chèque",
    [ModePaiement.VIREMENT]: "Virement",
    [ModePaiement.WEB]: "En ligne",
};

export const PaiementDtoSchema = z.object({
    id: z.number(),
    typeCible: z.nativeEnum(TypeCiblePaiement),
    idCible: z.number(),
    montant: z.number(),
    datePaiement: z.string(),
    mode: z.nativeEnum(ModePaiement),
    statut: z.nativeEnum(StatutPaiement),
    reference: z.string().nullable().optional(),
    commentaire: z.string().nullable().optional(),
});

/** Tel que renvoyé par le back : dates au format DD.MM.YYYY. */
export type PaiementBack = z.infer<typeof PaiementDtoSchema>;

export const SituationPaiementDtoSchema = z.object({
    typeCible: z.nativeEnum(TypeCiblePaiement),
    idCible: z.number(),
    montantTotal: z.number(),
    montantRegle: z.number(),
    resteAPayer: z.number(),
    statutReglement: z.nativeEnum(StatutReglement),
    paiements: z.array(PaiementDtoSchema),
});

export type SituationPaiement = z.infer<typeof SituationPaiementDtoSchema>;

/** Valeurs du formulaire de saisie, côté front les dates sont des Dayjs. */
export type PaiementFront = {
    montant: number;
    datePaiement: Dayjs;
    mode: ModePaiement;
    reference?: string;
    commentaire?: string;
};

export type PaiementErreur = {
    code?: string;
    message?: string;
};
